import React, { createContext, useEffect } from 'react';
import { CLIENT_DETAILS_OPTIONS, ROBOT_ENVIRONMENT } from '../../config/constants';

type robotEnvironmentType = {
    environment: ROBOT_ENVIRONMENT;
    googleAnalyticsCode?: string;
    contactDetailsOption?: CLIENT_DETAILS_OPTIONS;
    userToken?: string;
    userTokenIsNew?: boolean;
    children?: React.ReactNode;
}

export const RobotEnvironmentContext = createContext<robotEnvironmentType>({
    environment: undefined!,
    googleAnalyticsCode: undefined!,
    contactDetailsOption: undefined!,
    userToken: undefined,
    userTokenIsNew: undefined,
});

export const WithRobotEnvironment: React.FC<robotEnvironmentType> = ({
    environment,
    googleAnalyticsCode,
    contactDetailsOption,
    children,
    userToken,
    userTokenIsNew,
}) => {
    useEffect(() => {
        console.log('Robot running in', environment, 'environment.'); // eslint-disable-line
    }, [environment]);

    return (
        <RobotEnvironmentContext.Provider
            value={{
                environment,
                googleAnalyticsCode,
                contactDetailsOption,
                userToken,
                userTokenIsNew
            }}
        >
            {children}
        </RobotEnvironmentContext.Provider>
    );
};
